import { motion } from "framer-motion";
import {
  Truck, HardHat, Zap, Wrench, Snowflake, Home, Stethoscope, Smile, Scale, Calculator, Briefcase,
} from "lucide-react";

const INDUSTRIES = [
  { name: "Trucking & Transportation", Icon: Truck },
  { name: "Construction", Icon: HardHat },
  { name: "Electrical Contractors", Icon: Zap },
  { name: "Plumbing", Icon: Wrench },
  { name: "HVAC", Icon: Snowflake },
  { name: "Real Estate", Icon: Home },
  { name: "Medical Clinics", Icon: Stethoscope },
  { name: "Dental Offices", Icon: Smile },
  { name: "Law Firms", Icon: Scale },
  { name: "Accounting Firms", Icon: Calculator },
  { name: "Small Businesses", Icon: Briefcase },
];

export default function Industries() {
  return (
    <section id="industries" className="relative py-28 lg:py-36 overflow-hidden" data-testid="industries-section">
      <div className="container-apex">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 lg:sticky lg:top-24 self-start">
            <div className="overline">Industries</div>
            <h2 className="heading-display text-4xl sm:text-5xl mt-5">
              Trusted by <span className="text-[#16A34A]">11 industries</span> across Canada.
            </h2>
            <p className="mt-6 text-muted-foreground">
              From mid-sized fleets to single-clinic operators, we understand the paperwork rhythms of your sector and adapt fast.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-4">
            {INDUSTRIES.map((it, i) => (
              <motion.div
                key={it.name}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: (i % 6) * 0.05 }}
                className="card-apex p-6 h-32 flex flex-col justify-between group"
                data-testid={`industry-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <div className="w-10 h-10 rounded-lg bg-[#0B2545]/5 dark:bg-white/5 text-[#0B2545] dark:text-white group-hover:bg-[#16A34A] group-hover:text-white flex items-center justify-center transition-all">
                  <it.Icon size={18} />
                </div>
                <div className="font-display font-bold text-sm leading-tight">{it.name}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
